export var Observable = require('zen-observable');
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/zen-observable-ts/lib/zenObservable.js
// module id = 219
// module chunks = 0